var _rect, _path, _path2, _path3, _path4, _path5, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSmartMeasurement(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 76,
    height: 76,
    rx: 38,
    fill: "#FDE2E1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.8437 53.7152L51.1401 46.1597C51.3532 46.036 51.4907 45.8091 51.4907 45.5616V30.4366C51.4907 30.3747 51.4839 30.3128 51.4701 30.2578C51.4701 30.2372 51.4495 30.2166 51.4426 30.196L51.4014 30.0928C51.3876 30.0722 51.3739 30.0585 51.3601 30.0378C51.3395 30.0103 51.3189 29.976 51.2914 29.9553C51.2776 29.9416 51.257 29.9278 51.2364 29.9141C51.2089 29.8935 51.1814 29.866 51.1539 29.8453L37.8508 22.2825C37.6377 22.1656 37.3833 22.1656 37.1702 22.2825L23.8672 29.8453C23.8534 29.8522 23.8397 29.8728 23.8191 29.8797C23.8053 29.8935 23.7847 29.9003 23.7709 29.9141C23.7572 29.9278 23.7366 29.9347 23.7228 29.9485C23.6953 29.976 23.6816 30.0035 23.6541 30.031C23.6403 30.0516 23.6197 30.0653 23.6128 30.086C23.5991 30.1135 23.5853 30.1478 23.5716 30.1822C23.5647 30.2028 23.5509 30.2235 23.5441 30.2441C23.5441 30.2647 23.5441 30.2922 23.5372 30.3128C23.5372 30.3335 23.5372 30.3541 23.5303 30.3747C23.5303 30.3953 23.5234 30.4091 23.5234 30.4297V45.5547C23.5234 45.8022 23.6541 46.0291 23.8741 46.1528L37.1705 53.7084C37.1705 53.7084 37.2392 53.7427 37.2736 53.7565C37.2942 53.7634 37.3149 53.7771 37.3355 53.784C37.3905 53.7977 37.4524 53.8046 37.5142 53.8046C37.5761 53.8046 37.6311 53.7977 37.693 53.784C37.7136 53.784 37.7342 53.7702 37.7549 53.7565C37.7892 53.7427 37.8236 53.7359 37.858 53.7152H37.8437ZM50.1156 45.1624L38.1876 51.9409V38.3974L48.844 32.3404L48.8509 32.3335L50.109 31.6185V45.1621L50.1156 45.1624ZM37.5001 23.6643L49.4146 30.4363L48.0671 31.2063H48.0602L38.5657 36.6033L37.5001 37.2083L36.4345 36.6033L26.9401 31.2063H26.9332L25.5857 30.4363L37.5001 23.6643ZM24.8846 31.6188L26.1427 32.3338L26.1496 32.3407L36.806 38.3976V51.9412L24.878 45.1626V31.6191L24.8846 31.6188Z",
    fill: "url(#paint0_linear_2785_10359)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.625 26.313C20.0031 26.313 20.3125 26.0036 20.3125 25.6255V21.5005C20.3125 21.1224 20.6219 20.813 21 20.813H25.125C25.5031 20.813 25.8125 20.5036 25.8125 20.1255C25.8125 19.7474 25.5031 19.438 25.125 19.438H21C19.8656 19.438 18.9375 20.3661 18.9375 21.5005V25.6255C18.9375 26.0036 19.2469 26.313 19.625 26.313Z",
    fill: "url(#paint1_linear_2785_10359)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.125 55.1855H21C20.6219 55.1855 20.3125 54.8762 20.3125 54.498V50.373C20.3125 49.9949 20.0031 49.6855 19.625 49.6855C19.2469 49.6855 18.9375 49.9949 18.9375 50.373V54.498C18.9375 55.6324 19.8656 56.5605 21 56.5605H25.125C25.5031 56.5605 25.8125 56.2512 25.8125 55.873C25.8125 55.4949 25.5031 55.1855 25.125 55.1855Z",
    fill: "url(#paint2_linear_2785_10359)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M55.375 49.687C54.9969 49.687 54.6875 49.9964 54.6875 50.3745V54.4995C54.6875 54.8776 54.3781 55.187 54 55.187H49.875C49.4969 55.187 49.1875 55.4964 49.1875 55.8745C49.1875 56.2526 49.4969 56.562 49.875 56.562H54C55.1344 56.562 56.0625 55.6339 56.0625 54.4995V50.3745C56.0625 49.9964 55.7531 49.687 55.375 49.687Z",
    fill: "url(#paint3_linear_2785_10359)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M54 19.4375H49.875C49.4969 19.4375 49.1875 19.7469 49.1875 20.125C49.1875 20.5031 49.4969 20.8125 49.875 20.8125H54C54.3781 20.8125 54.6875 21.1219 54.6875 21.5V25.625C54.6875 26.0031 54.9969 26.3125 55.375 26.3125C55.7531 26.3125 56.0625 26.0031 56.0625 25.625V21.5C56.0625 20.3656 55.1344 19.4375 54 19.4375Z",
    fill: "url(#paint4_linear_2785_10359)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2785_10359",
    x1: 23.5234,
    y1: 37.9997,
    x2: 51.4907,
    y2: 37.9997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC4645"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A1D1D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2785_10359",
    x1: 18.9375,
    y1: 22.8755,
    x2: 25.8125,
    y2: 22.8755,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC4645"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A1D1D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2785_10359",
    x1: 18.9375,
    y1: 53.123,
    x2: 25.8125,
    y2: 53.123,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC4645"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A1D1D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2785_10359",
    x1: 49.1875,
    y1: 53.1245,
    x2: 56.0625,
    y2: 53.1245,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC4645"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A1D1D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2785_10359",
    x1: 49.1875,
    y1: 22.875,
    x2: 56.0625,
    y2: 22.875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC4645"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A1D1D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmartMeasurement);
export default __webpack_public_path__ + "static/media/Smart Measurement.b85f658e0f4f9f9478f8af474af191dc.svg";
export { ForwardRef as ReactComponent };